const ERROR_REQUIRED = 'This field is required.';

export type ChampionConsentFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  agreePrivacy: boolean;
  agreeNda: boolean;
};

export type ChampionConsentFormErrors = Partial<Record<keyof ChampionConsentFormValues, string>>;

export const validateChampionConsentForm = (
  values: ChampionConsentFormValues
): ChampionConsentFormErrors => {
  const errors: ChampionConsentFormErrors = {};

  if (!values.firstName.trim()) {
    errors.firstName = ERROR_REQUIRED;
  }

  if (!values.lastName.trim()) {
    errors.lastName = ERROR_REQUIRED;
  }

  if (!values.agreePrivacy) {
    errors.agreePrivacy = ERROR_REQUIRED;
  }

  if (!values.agreeNda) {
    errors.agreeNda = ERROR_REQUIRED;
  }

  return errors;
};
